const COMBINING_MARKS_REGEX = /[\u0300-\u036f]/g;

export const normalizeSearch = (value: string): string => {
 return value
  .normalize('NFD')
  .replace(COMBINING_MARKS_REGEX, '')
  .toLowerCase();
};

export const findNormalizedMatchRange = (
 text: string,
 query: string,
): { start: number; end: number } | null => {
 const normalizedQuery = normalizeSearch(query);
 if (!normalizedQuery) return null;
 const normalizedChars: string[] = [];
 const indexMap: number[] = [];
 for (let i = 0; i < text.length; i++) {
  const normalizedChar = normalizeSearch(text[i]);
  if (!normalizedChar) continue;
  for (let j = 0; j < normalizedChar.length; j++) {
   normalizedChars.push(normalizedChar[j]);
   indexMap.push(i);
  }
 }
 const normalizedText = normalizedChars.join('');
 const startNormalized = normalizedText.indexOf(normalizedQuery);
 if (startNormalized === -1) return null;
 const endNormalized = startNormalized + normalizedQuery.length;
 const start = indexMap[startNormalized];
 const end = endNormalized < indexMap.length ? indexMap[endNormalized] : text.length;
 return { start, end };
};

